import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Tooltip } from 'components';
import SubmitModal from "../../components/layout/components/submitModal";
import { isAuditor } from 'utils';
import { isNil, omit, isEmpty } from 'lodash';
import { getLocalString, localNames } from "utils/localisation.service";
import { handleSubmit } from "utils";
import { submitTask, updateFormField } from "store/forms/actions";
import { ReturnModal } from './components';

const FormFooter = ({ actions, current, setCurrent, currentSubTab, steps, tabs }) => {
  const locales = useSelector(state => state.forms?.localeStrings);
  const task = useSelector(state => state.forms.task);
  const state = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  const documents = useSelector(state => state.forms.documents);
  const businessKey = useSelector(state => state.forms.businessKey);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [outcome, setOutcome] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState('');
  const params = useParams();
  const location = useLocation();
  
  

  useEffect(() => {
    // Code to run on component mount
    if(isVisible && isAuditor(user?.groups)){
      setOutcome('return')
    }
  }, [isVisible]); 

  useEffect(() => {
    // Code to run when 'current' changes
  }, [current]);


  const finalTabs = tabs?.map(item => {
      if (item?.tabsComponent) {
          return {
              ...item,
              tabsComponent: item?.tabsComponent.filter(tab => tab.disabled === false)
          };
      }
      return item;
  });

  const setPrev = (current) => {
    setCurrent(current);
    dispatch(
      updateFormField({
        group: 'carrier',
        key:'currentSubTab',
        value: finalTabs[current]?.subtabs ? finalTabs[current]?.tabsComponent?.length - 1 : 0,
      })
    )
  }

  const setNext = (current) => {
    setCurrent(current + 1);
    dispatch(
      updateFormField({
        group: 'carrier',
        key:'currentSubTab',
        value: 0,
      })
    )
  }


  const commonActions = [
    current !== 0 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      className: 'dark-grey',
      onClick: () => {
        setPrev(current - 1)
      }
    },
    current !== (!isNil(steps) ? steps?.length - 1 : finalTabs?.length - 1) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      className: 'brown-grey',
      onClick: () => {
        setCurrent(current + 1);
      }
    },
  ].filter(Boolean);

  const commonActionsSub = [
    (currentSubTab !== 0 || current !== 0) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () => currentSubTab !== 0 ? dispatch(
        updateFormField({
          group: 'carrier',
          key:'currentSubTab',
          value: currentSubTab -1 ,
        })
      ) : setPrev(current - 1)
    },
    ( finalTabs[current]?.tabsComponent && ((currentSubTab !== finalTabs[current]?.tabsComponent?.length -1) || current !== (finalTabs?.length - 1 ) || current !== (!isNil(steps) ? steps?.length - 1 : finalTabs?.length - 1))) &&
       {
          label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
          type: 'primary',
          id: 'next-step-btn',
          className: 'brown-grey',
          onClick: () => currentSubTab !== finalTabs[current]?.tabsComponent?.length -1 ? dispatch(
            updateFormField({
              group: 'carrier',
              key:'currentSubTab',
              value: finalTabs[current]?.tabsComponent[currentSubTab + 1].id //currentSubTab + 1,
              
            })
          ) : setNext(current)  
      },
  ].filter(Boolean);

  const specialActions = [
    {
      label: 'Επιστροφή στον Ωφελούμενο',
      id: 'return-to-investor',
      type: 'default',
      className: 'dark-grey',
      // tooltipTitle:
      //   'Επιστροφή για υποβολή αιτήματος αλλαγής στοιχείων / δικαιολογητικών',
      visible: tooltipVisible === 'return-to-investor',
      onVisibleChange: v => setTooltipVisible(v ? 'return-to-investor' : ''),
      onClick: () => {
        setIsVisible(true);
      },
      disabled: false,//isEmpty(documents?.audDocsCompletenessReport),
    },
  ].filter(item => item);

  return (
    <div className="form-footer">
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        businessKey={businessKey}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() => handleSubmit({
          state: { ...state },
          task,
          user: { ...user },
          dispatch,
          submitTask,
          navigate,
          setIsVisible,
          taskId: params.taskId,
          formKey: task.formKey,
          outcome,
        })}
      />

      {/* Divider line */}
      <div className="form-footer__divider"></div>

      {/* Wrapper to handle button alignment */}
      <div className="form-footer__actions-wrapper">
        {(isAuditor(user?.groups) ) && current === 3 && !viewMode && !window.location.href.includes('apptrack') && (
          <div className="form-footer__actions">
            {!isEmpty(specialActions) &&
              specialActions?.map((action, index) => (
                <Button
                  key={'special-btn-' + index}
                  {...action}
                />
              ))}
           </div>
        )}
       <div className="form-footer__actions right-placement">
          {finalTabs[current]?.subtabs ? commonActionsSub?.map((action, index) => (
            <Button key={index} {...action} />
          )) : 
          commonActions?.map((action, index) => (
              <Button
                key={'common-btn-' + index}
                {...action}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
